import appStore from 'store';
import api from './api';
import { PAGINATION, RECORD_STATUS, TASK_STATUS, TASK_BALANCE_TYPE, TASK_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    coinList:[],
    taskList: [],
    recordList: [],
    totalCount: 0,
    recordTotalCount: 0,
    pagination: PAGINATION,
    recordPagination: PAGINATION,
    recordDialogVisible: false,
    checkTask: {},
    taskType: TASK_TYPE,
    taskBalanceType: TASK_BALANCE_TYPE
  },
  mutations: {
    setTaskList(state, payload) {
      state.taskList = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setTaskTotal(state, payload) {
      state.totalCount = payload;
    },
    setRecordList(state, payload) {
      state.recordList = payload;
    },
    setRecordPagination(state, payload) {
      state.recordPagination = payload;
    },
    setRecordTotal(state, payload) {
      state.recordTotalCount = payload;
    },
    setProfit(state, payload) {
      state.profit = payload;
    },
    setRecordDialogVisible(state, payload) {
      state.recordDialogVisible = payload;
    },
    setCheckTask(state, payload) {
      state.checkTask = payload;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  getters: {
    taskList(state) {
      return state.taskList.map(item => {
        return {
          ...item,
          __type: (TASK_TYPE.find(type => type.value === item.type ) || {}).label || item.type,
          __fromType: (TASK_BALANCE_TYPE.find(type => type.value === item.fromType ) || {}).label || item.fromType,
          __toType: (TASK_BALANCE_TYPE.find(type => type.value === item.toType ) || {}).label || item.toType,
          __status: TASK_STATUS[item.status]
        };
      });
    },
    recordList(state) {
      return state.recordList.map(item => {
        return {
          ...item,
          __status: RECORD_STATUS[item.status]
        };
      });
    }
  },
  actions: {
    templateDownload({commit}){
     return api.templateDownload().then(res=>{
       
        return res
      })
    },
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    list({ commit }, query) {
      commit('setPagination', { page: query.page, size: query.size });

      api.listTasks(query).then(({ data }) => {
        commit('setTaskList', data.list);
        commit('setTaskTotal', data.totalCount);
      });
    },
    create(context, data) {
      return api.createTask(data);
    },
    update(context, data) {
      return api.updateTask(data);
    },
    remove({ commit }, id) {
      return api.removeTask(id);
    },
    execute({ commit }, {id,googleCode}) {
      return api.executeTask({id,googleCode});
    },
    listRecords({ commit }, query) {
      commit('setRecordPagination', { page: query.page, size: query.size });

      return api.listRecords(query).then(({ data }) => {
        commit('setRecordList', data.list);
        commit('setRecordTotal', data.totalCount);
      });
    },
    billTask(context, taskId) {
      return api.billTask({ taskId });
    },
    executeRecord(context, {id,googleCode}) {
      return api.executeRecord({id,googleCode});
    },
    removeRecord(context, id) {
      return api.removeRecord(id);
    },
    createRecord(context, data) {
      return api.createRecord(data);
    }
  }
};

appStore.registerModule('airdrop', store);
